export const StripePriceIds = {
    pro: {
        month: 'price_1Sq8Bm2OSOtDCZAqXK3Nfbk6',
        year: 'price_1Sq8Bm2OSOtDCZAqXTsQ3YCB',
    },
    pro_plus: {
        month: 'price_1Sq8HO2OSOtDCZAqxzQg9mgX',
        year: 'price_1Sq8Hz2OSOtDCZAqRwsvdSyT',
    },
};
export const StripeProductIds = {
    pro: 'prod_TnjfNq9uxMF5M2',
    pro_plus: 'prod_Tnjk2QAOSFFYSH',
};
const Pricing = {
    pro: {
        monthly: 999,
        yearly: 9900,
    },
    pro_plus: {
        monthly: 1999,
        yearly: 19900,
    },
};
const ProFeatures = [
    {
        name: 'Complete Session Workflow',
        description: 'Pre-trading rituals, live capture, and post-session review',
    },
    {
        name: 'Trade Journal',
        description: 'Log and analyze every trade with detailed entry/exit data',
    },
    {
        name: 'Performance Analytics',
        description: 'Track win rate, P&L, and key performance metrics',
    },
    {
        name: 'Cloud Sync',
        description: 'Sync your data across devices with Google Drive',
    },
    {
        name: 'Mobile Responsive',
        description: 'Access your journal from any device',
    },
    {
        name: 'Economic Calendar',
        description: 'Stay informed about market-moving events',
    },
];
const ProPlusFeatures = [
    ...ProFeatures,
    {
        name: 'Advanced Analytics Dashboard',
        description: 'Deep insights into your trading patterns and behaviors',
        highlighted: true,
    },
    {
        name: 'AI-Powered Insights',
        description: 'Get personalized recommendations (bring your own API key)',
        highlighted: true,
    },
    {
        name: 'Priority Support',
        description: 'Get help faster with priority email support',
        highlighted: true,
    },
    {
        name: 'Early Access',
        description: 'Be first to try new features before general release',
        highlighted: true,
    },
];
const ProPlan = {
    id: 'pro',
    name: 'Pro',
    description: 'Everything you need to build consistent trading habits',
    monthly: {
        stripePriceId: StripePriceIds.pro.month,
        amountCents: Pricing.pro.monthly,
        displayPrice: '$9.99',
        interval: 'month',
    },
    yearly: {
        stripePriceId: StripePriceIds.pro.year,
        amountCents: Pricing.pro.yearly,
        displayPrice: '$99',
        interval: 'year',
        perMonthEquivalent: '$8.25/mo',
        savingsPercent: 17,
    },
    features: ProFeatures,
};
const ProPlusPlan = {
    id: 'pro_plus',
    name: 'Pro+',
    description: 'Advanced tools for serious traders who want an edge',
    badge: 'Most Popular',
    recommended: true,
    monthly: {
        stripePriceId: StripePriceIds.pro_plus.month,
        amountCents: Pricing.pro_plus.monthly,
        displayPrice: '$19.99',
        interval: 'month',
    },
    yearly: {
        stripePriceId: StripePriceIds.pro_plus.year,
        amountCents: Pricing.pro_plus.yearly,
        displayPrice: '$199',
        interval: 'year',
        perMonthEquivalent: '$16.58/mo',
        savingsPercent: 17,
    },
    features: ProPlusFeatures,
};
export const Plans = {
    pro: ProPlan,
    pro_plus: ProPlusPlan,
};
export const PlansArray = [ProPlan, ProPlusPlan];
export const DefaultPlan = 'pro';
export const DefaultBillingInterval = 'month';
export function getStripePriceId(planType, interval) {
    return StripePriceIds[planType][interval];
}
export function getPlanConfig(planType) {
    return Plans[planType];
}
export function getPlanPrice(planType, interval) {
    const plan = Plans[planType];
    return interval === 'month' ? plan.monthly : plan.yearly;
}
const PriceIdToPlanMap = {
    [StripePriceIds.pro.month]: {
        planType: 'pro',
        interval: 'month',
        amountCents: Pricing.pro.monthly,
    },
    [StripePriceIds.pro.year]: {
        planType: 'pro',
        interval: 'year',
        amountCents: Pricing.pro.yearly,
    },
    [StripePriceIds.pro_plus.month]: {
        planType: 'pro_plus',
        interval: 'month',
        amountCents: Pricing.pro_plus.monthly,
    },
    [StripePriceIds.pro_plus.year]: {
        planType: 'pro_plus',
        interval: 'year',
        amountCents: Pricing.pro_plus.yearly,
    },
};
export function getPlanFromPriceId(priceId) {
    return PriceIdToPlanMap[priceId] || null;
}
export function getAllStripePriceIds() {
    return Object.keys(PriceIdToPlanMap);
}
export function isValidPriceId(priceId) {
    return priceId in PriceIdToPlanMap;
}
export function formatPrice(amountCents) {
    const dollars = amountCents / 100;
    return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
}
export function calculateAnnualSavings(planType) {
    const monthly = Pricing[planType].monthly;
    const yearly = Pricing[planType].yearly;
    const monthlyAnnualized = monthly * 12;
    const savings = monthlyAnnualized - yearly;
    const savingsPercent = Math.round((savings / monthlyAnnualized) * 100);
    return {
        monthlyCost: monthly,
        yearlyCost: yearly,
        savings,
        savingsPercent,
    };
}
//# sourceMappingURL=plans.js.map